import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';
import { DelayedCampaignCreationMethodSelectionStepWithI18n } from './delayed-campaign-creation-method-selection-step';

export const CampaignCreationMethodSelectionStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_CREATION_METHOD_SELECTION,
  view: DelayedCampaignCreationMethodSelectionStepWithI18n,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
    guards: {
      needsLoading: () => false,
      needsSaving: () => false,
    },
  },
};
